import { Component, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { OrderService } from "../../order.service";
import { ActivePageEnum } from "../../model/activepage.enum";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Subscription, timer } from "rxjs";
import { map, take } from "rxjs/operators";
import { InvoicePrintService } from "../../providers/invoiceprint.service";
import { GroupByPipe } from "projects/sepidz-web-framework/src/lib/pipes/group-by.pipe";
import { SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";

@Component({
  selector: "order-header",
  templateUrl: "./orderheader.component.html",
  styleUrls: ["./orderheader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderHeaderComponent extends BaseListComponent {
  @Output() onBtnClicked = new EventEmitter<ActivePageEnum>();
  activePageEnum: typeof ActivePageEnum = ActivePageEnum;
  rowState: typeof RowState = RowState;
  timerSubscription: Subscription;
  constructor(
    public order: OrderService,
    private cd: ChangeDetectorRef,
    private printService: InvoicePrintService,
    private storage: LocalStoreManager
  ) {
    super();
    this.NoLog = true;
    this.order.cd_Header = cd;
  }
  async ngOnInit() {
    this.timerSubscription = timer(0, 60000)
      .pipe(
        map(async () => {
          await this.PrinterQueue(); // load data contains the http request
        })
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.timerSubscription.unsubscribe();
  }

  async PrinterQueue() {
    const computerName: string = this.storage.getData(ClearableCache.ComputerName);
    const branches = this.order.Branches.filter((f) => f.IsActive);
    if (branches?.length > 0 && this.order.isMultiBranch) {
      this.order.printerQueue = [];
      branches.forEach((branch) => {
        const printers: any[] = [];
        if (branch?.HasLocalService) {
          const url = "http://" + branch.LocalServiceIp + "/PrinterQueue";
          this.printService?.PrintPolicy?.forEach((element) => {
            if (element) {
              element?.Printers?.forEach((ele) => {
                printers.push(ele.Name);
              });
            }
          });

          this.httpCommonService
            .postCustom(url, printers)
            .pipe(take(1))
            .subscribe(async (data: any[]) => {
              data?.forEach((ele) => {
                ele.BranchTitle = branch?.Title;
                this.order.printerQueue.push(ele);
              });
              this.cd.markForCheck();
            });
        }
      });
    } else {
      if (this.order.currentBranch?.HasLocalService) {
        const url = "http://" + this.order.currentBranch.LocalServiceIp + "/PrinterQueue";
        const printers: any[] = [];
        this.printService?.PrintPolicy?.forEach((element) => {
          if (element) {
            element?.Printers?.forEach((ele) => {
              printers.push(ele.Name);
            });
          }
        });
        await this.httpCommonService
          .postCustom(url, printers)
          .pipe(take(1))
          .subscribe(async (data: any[]) => {
            this.order.printerQueue = data;
            this.cd.markForCheck();
          });
      } else {
        await this.httpCommonService
          .getList("Invoice/PrinterQueue")
          .pipe(take(1))
          .subscribe(async (data: any[]) => {
            this.order.printerQueue = data;
            this.cd.markForCheck();
          });
      }
      if (this.printService.HasLocalPrint) {
        const group = new GroupByPipe();
        const newList = group.transform(this.printService.PrintPolicy, ["LocalServiceIp"]);
        newList?.forEach((element) => {
          if (element?.key && element?.key !== "undefined" && element?.value) {
            const url = "http://" + element.key + "/PrinterQueue";
            const printersList: any[] = [];
            const printers: any[] = [];
            element?.value?.forEach((ele) => {
              if (ele.HasLocalSetting && ele.LocalServiceIp && ele.ComputerName) {
                if (ele.ComputerName?.replace(".local", "") === computerName?.replace(".local", "")) printersList.push(ele.Printers);
              } else {
                printersList.push(ele.Printers);
              }
            });
            if(printersList.length > 0)
            {
              printersList?.forEach((x) => {
                if (!printers.some((x) => x === x[0].Name)) printers.push(x[0].Name);
              });              
            }
            if (printers && printers.length > 0) {
              this.httpCommonService
                .postCustom(url, printers)
                .pipe(take(1))
                .subscribe(
                  async (data: any) => {
                    this.order.printerQueue = data;
                    this.cd.markForCheck();
                  },
                  (err) => {
                    console.log(err);
                  }
                );
            }
          }
        });
      }
    }
  }

  setDestinationPage(): void {
    switch (this.order.currentSaleMethodNature) {
      case SaleMethodNature.FastFood:
        this.order.shouldActivateSalonPage = false;
        this.order.shouldActivateInvoicesPage = false;
        break;
      case SaleMethodNature.Delivery:
        this.order.shouldActivateSalonPage = false;
        this.order.shouldActivateInvoicesPage = false;
        break;
      case SaleMethodNature.Restaurant:
        this.order.shouldActivateSalonPage = true;
        this.order.shouldActivateInvoicesPage = false;
        break;
    }
  }

  onInvoicesListClick(): void {
    this.onBtnClicked.emit(ActivePageEnum.Invoices);
    this.order.shouldActivateSalonPage = false;
    this.order.shouldActivateInvoicesPage = true;
  }

  onOrderClick(): void {
    this.order.shouldActivateSalonPage = false;
    this.order.shouldActivateInvoicesPage = false;
  }

  onSalonClick() {
    this.onBtnClicked.emit(ActivePageEnum.Salon);
  }
}
